/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BugReportViewerRouteImport } from './routes/bug-report-viewer'
import { Route as CardCreatorRouteImport } from './routes/card-creator'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CustomFramesRouteImport } from './routes/custom-frames'
import { Route as ExportRouteImport } from './routes/export'
import { Route as FabbleRouteImport } from './routes/fabble'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as PresetRouteImport } from './routes/preset'
import { Route as ResetFormRouteImport } from './routes/reset-form'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as FabbleIndexRouteImport } from './routes/fabble.index'
import { Route as FabbleChaosRouteImport } from './routes/fabble.chaos'
import { Route as FabbleEndlessRouteImport } from './routes/fabble.endless'
import { Route as FabbleStandardRouteImport } from './routes/fabble.standard'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BugReportViewerRoute = BugReportViewerRouteImport.update({
  id: '/bug-report-viewer',
  path: '/bug-report-viewer',
  getParentRoute: () => rootRouteImport,
} as any)
const CardCreatorRoute = CardCreatorRouteImport.update({
  id: '/card-creator',
  path: '/card-creator',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomFramesRoute = CustomFramesRouteImport.update({
  id: '/custom-frames',
  path: '/custom-frames',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const FabbleRoute = FabbleRouteImport.update({
  id: '/fabble',
  path: '/fabble',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const PresetRoute = PresetRouteImport.update({
  id: '/preset',
  path: '/preset',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetFormRoute = ResetFormRouteImport.update({
  id: '/reset-form',
  path: '/reset-form',
  getParentRoute: () => rootRouteImport,
} as any)
const RoadmapRoute = RoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => rootRouteImport,
} as any)
const FabbleIndexRoute = FabbleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FabbleRoute,
} as any)
const FabbleChaosRoute = FabbleChaosRouteImport.update({
  id: '/chaos',
  path: '/chaos',
  getParentRoute: () => FabbleRoute,
} as any)
const FabbleEndlessRoute = FabbleEndlessRouteImport.update({
  id: '/endless',
  path: '/endless',
  getParentRoute: () => FabbleRoute,
} as any)
const FabbleStandardRoute = FabbleStandardRouteImport.update({
  id: '/standard',
  path: '/standard',
  getParentRoute: () => FabbleRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bug-report-viewer': typeof BugReportViewerRoute
  '/card-creator': typeof CardCreatorRoute
  '/contact': typeof ContactRoute
  '/custom-frames': typeof CustomFramesRoute
  '/export': typeof ExportRoute
  '/fabble': typeof FabbleRouteWithChildren
  '/gallery': typeof GalleryRoute
  '/preset': typeof PresetRoute
  '/reset-form': typeof ResetFormRoute
  '/roadmap': typeof RoadmapRoute
  '/fabble/chaos': typeof FabbleChaosRoute
  '/fabble/endless': typeof FabbleEndlessRoute
  '/fabble/standard': typeof FabbleStandardRoute
  '/fabble/': typeof FabbleIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bug-report-viewer': typeof BugReportViewerRoute
  '/card-creator': typeof CardCreatorRoute
  '/contact': typeof ContactRoute
  '/custom-frames': typeof CustomFramesRoute
  '/export': typeof ExportRoute
  '/gallery': typeof GalleryRoute
  '/preset': typeof PresetRoute
  '/reset-form': typeof ResetFormRoute
  '/roadmap': typeof RoadmapRoute
  '/fabble/chaos': typeof FabbleChaosRoute
  '/fabble/endless': typeof FabbleEndlessRoute
  '/fabble/standard': typeof FabbleStandardRoute
  '/fabble': typeof FabbleIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bug-report-viewer': typeof BugReportViewerRoute
  '/card-creator': typeof CardCreatorRoute
  '/contact': typeof ContactRoute
  '/custom-frames': typeof CustomFramesRoute
  '/export': typeof ExportRoute
  '/fabble': typeof FabbleRouteWithChildren
  '/gallery': typeof GalleryRoute
  '/preset': typeof PresetRoute
  '/reset-form': typeof ResetFormRoute
  '/roadmap': typeof RoadmapRoute
  '/fabble/chaos': typeof FabbleChaosRoute
  '/fabble/endless': typeof FabbleEndlessRoute
  '/fabble/standard': typeof FabbleStandardRoute
  '/fabble/': typeof FabbleIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bug-report-viewer'
    | '/card-creator'
    | '/contact'
    | '/custom-frames'
    | '/export'
    | '/fabble'
    | '/gallery'
    | '/preset'
    | '/reset-form'
    | '/roadmap'
    | '/fabble/chaos'
    | '/fabble/endless'
    | '/fabble/standard'
    | '/fabble/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bug-report-viewer'
    | '/card-creator'
    | '/contact'
    | '/custom-frames'
    | '/export'
    | '/gallery'
    | '/preset'
    | '/reset-form'
    | '/roadmap'
    | '/fabble/chaos'
    | '/fabble/endless'
    | '/fabble/standard'
    | '/fabble'
  id:
    | '__root__'
    | '/'
    | '/bug-report-viewer'
    | '/card-creator'
    | '/contact'
    | '/custom-frames'
    | '/export'
    | '/fabble'
    | '/gallery'
    | '/preset'
    | '/reset-form'
    | '/roadmap'
    | '/fabble/chaos'
    | '/fabble/endless'
    | '/fabble/standard'
    | '/fabble/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BugReportViewerRoute: typeof BugReportViewerRoute
  CardCreatorRoute: typeof CardCreatorRoute
  ContactRoute: typeof ContactRoute
  CustomFramesRoute: typeof CustomFramesRoute
  ExportRoute: typeof ExportRoute
  FabbleRoute: typeof FabbleRouteWithChildren
  GalleryRoute: typeof GalleryRoute
  PresetRoute: typeof PresetRoute
  ResetFormRoute: typeof ResetFormRoute
  RoadmapRoute: typeof RoadmapRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bug-report-viewer': {
      id: '/bug-report-viewer'
      path: '/bug-report-viewer'
      fullPath: '/bug-report-viewer'
      preLoaderRoute: typeof BugReportViewerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card-creator': {
      id: '/card-creator'
      path: '/card-creator'
      fullPath: '/card-creator'
      preLoaderRoute: typeof CardCreatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/custom-frames': {
      id: '/custom-frames'
      path: '/custom-frames'
      fullPath: '/custom-frames'
      preLoaderRoute: typeof CustomFramesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fabble': {
      id: '/fabble'
      path: '/fabble'
      fullPath: '/fabble'
      preLoaderRoute: typeof FabbleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preset': {
      id: '/preset'
      path: '/preset'
      fullPath: '/preset'
      preLoaderRoute: typeof PresetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-form': {
      id: '/reset-form'
      path: '/reset-form'
      fullPath: '/reset-form'
      preLoaderRoute: typeof ResetFormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roadmap': {
      id: '/roadmap'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof RoadmapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fabble/': {
      id: '/fabble/'
      path: '/'
      fullPath: '/fabble/'
      preLoaderRoute: typeof FabbleIndexRouteImport
      parentRoute: typeof FabbleRoute
    }
    '/fabble/chaos': {
      id: '/fabble/chaos'
      path: '/chaos'
      fullPath: '/fabble/chaos'
      preLoaderRoute: typeof FabbleChaosRouteImport
      parentRoute: typeof FabbleRoute
    }
    '/fabble/endless': {
      id: '/fabble/endless'
      path: '/endless'
      fullPath: '/fabble/endless'
      preLoaderRoute: typeof FabbleEndlessRouteImport
      parentRoute: typeof FabbleRoute
    }
    '/fabble/standard': {
      id: '/fabble/standard'
      path: '/standard'
      fullPath: '/fabble/standard'
      preLoaderRoute: typeof FabbleStandardRouteImport
      parentRoute: typeof FabbleRoute
    }
  }
}

interface FabbleRouteChildren {
  FabbleChaosRoute: typeof FabbleChaosRoute
  FabbleEndlessRoute: typeof FabbleEndlessRoute
  FabbleStandardRoute: typeof FabbleStandardRoute
  FabbleIndexRoute: typeof FabbleIndexRoute
}

const FabbleRouteChildren: FabbleRouteChildren = {
  FabbleChaosRoute: FabbleChaosRoute,
  FabbleEndlessRoute: FabbleEndlessRoute,
  FabbleStandardRoute: FabbleStandardRoute,
  FabbleIndexRoute: FabbleIndexRoute,
}

const FabbleRouteWithChildren =
  FabbleRoute._addFileChildren(FabbleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BugReportViewerRoute: BugReportViewerRoute,
  CardCreatorRoute: CardCreatorRoute,
  ContactRoute: ContactRoute,
  CustomFramesRoute: CustomFramesRoute,
  ExportRoute: ExportRoute,
  FabbleRoute: FabbleRouteWithChildren,
  GalleryRoute: GalleryRoute,
  PresetRoute: PresetRoute,
  ResetFormRoute: ResetFormRoute,
  RoadmapRoute: RoadmapRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
